export const SHOP_THE_LIST_TEXT = $localize`:ProductLists|Shop list button@@shopTheListButton: Shop the list`;
export const SHOP_THE_LOOK_TEXT = $localize`:ProductLists|Shop look button@@shopTheLookButton: Shop the look`;
export const SHOP_THE_LIST_LOADING = $localize`:ProductLists|Shop list button loading@@shopTheListButtonLoading: Loading the list...`;
export const PROMOTED_TEXT = $localize`:Spotlight| Promoted via spotlight@@promotedViaSpotlightText:Promoted`;
export const PROMOTE_TEXT = $localize`:Spotlight| Promote via spotlight@@promoteViaSpotlightText:Promote`;
export const ADD_TO_BASKET_TEXT = '';
